(() => {
  const $ = (s, c=document) => c.querySelector(s);
  const $$ = (s, c=document) => Array.from(c.querySelectorAll(s));
  const asId = v => String(v||'').match(/(\d{8,})$/)?.[1];
  const money = (cents, cur = (window.Shopify?.currency?.active || 'USD')) =>
    (Number(cents||0)/100).toLocaleString('en-US', { style:'currency', currency: cur });

  // Insert drawer HTML once if not present
  function ensureDrawer(){
    if ($('#mds-cart')) return;
    const tpl = document.createElement('template');
    tpl.innerHTML = `
    <!-- MDS Cart Drawer -->
    <div id="mds-cart" class="mds-cart" aria-hidden="true">
      <div class="mds-cart__backdrop" data-mds-cart-close></div>
      <aside class="mds-cart__panel" role="dialog" aria-labelledby="mdsCartTitle" aria-modal="true">
        <header class="mds-cart__header d-flex justify-content-between align-items-center">
          <h2 id="mdsCartTitle" class="h5 m-0">Just added</h2>
          <button type="button" class="btn btn-sm btn-outline-secondary" data-mds-cart-close>Close</button>
        </header>
        <div class="mds-cart__body">
          <div id="mdsCartItems" class="mds-cart__items"></div>
          <div id="mdsCartDiscounts" class="mds-cart__discounts"></div>
        </div>
        <footer class="mds-cart__footer">
          <div id="mdsCartShippingProgress" class="mds-cart__shipping-progress mb-3">
            <div class="mds-cart__shipping-text">
              <span id="mdsShippingMessage"></span>
            </div>
            <div class="mds-cart__progress-bar">
              <div id="mdsProgressFill" class="mds-cart__progress-fill"></div>
            </div>
          </div>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>Subtotal</strong><strong id="mdsCartSubtotal">$0.00</strong>
          </div>
          <div class="text-muted small mb-3">Excludes shipping & taxes</div>
          <div class="d-flex gap-2">
            <a href="#" class="btn btn-outline-dark w-100" data-mds-cart-close>Keep Shopping</a>
            <a href="/cart" class="btn btn-dark w-100">Cart</a>
          </div>
        </footer>
      </aside>
    </div>`;
    document.body.appendChild(tpl.content);
  }

  async function cartGet(){ const r = await fetch('/cart.js',{headers:{'Accept':'application/json'}}); return r.json(); }
  async function cartAdd(variantId, qty=1){
    const r = await fetch('/cart/add.js',{
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: asId(variantId), quantity: qty })
    });
    if(!r.ok) throw await r.json().catch(()=>({status:r.status}));
    return r.json();
  }
  async function cartChange(keyOrLine, qty){
    const body = (String(keyOrLine).includes(':')) ? { id:keyOrLine, quantity:qty } : { line:keyOrLine, quantity:qty };
    const r = await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify(body)});
    if(!r.ok) throw await r.json().catch(()=>({status:r.status}));
    return r.json();
  }

  function updateHeaderCount(count){
    $$('.cart-count-bubble, [data-cart-count], .header__cart-count').forEach(el => el.textContent = count);
  }

  function openDrawer(){
    ensureDrawer();
    const root = $('#mds-cart'); if(!root) return;
    root.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
    root.querySelector('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])')?.focus();
  }
  function closeDrawer(){
    const root = $('#mds-cart'); if(!root) return;
    root.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
  }

  // Expose globally for external use
  window.MDSCart = { 
    open: openDrawer, 
    close: closeDrawer, 
    get: cartGet, 
    render: renderCart,
    updateCount: updateHeaderCount 
  };

  function updateShippingProgress(cartTotal) {
    const FREE_SHIPPING_THRESHOLD = 50000; // $500 in cents
    const messageEl = $('#mdsShippingMessage');
    const fillEl = $('#mdsProgressFill');
    
    if (!messageEl || !fillEl) return;
    
    const remaining = FREE_SHIPPING_THRESHOLD - cartTotal;
    const percentage = Math.min(100, (cartTotal / FREE_SHIPPING_THRESHOLD) * 100);
    
    fillEl.style.width = percentage + '%';
    
    if (cartTotal >= FREE_SHIPPING_THRESHOLD) {
      messageEl.innerHTML = '🎉 <strong>You qualify for FREE shipping!</strong>';
      fillEl.style.backgroundColor = '#22c55e'; // green
    } else {
      messageEl.innerHTML = `Add <strong>${money(remaining)}</strong> more for <strong>FREE shipping</strong>`;
      fillEl.style.backgroundColor = '#3b82f6'; // blue
    }
  }

  function renderCart(cart){
    const list = $('#mdsCartItems'); if(!list) return;
    list.innerHTML = '';
    (cart.items||[]).forEach((it, i) => {
      const unitOld = it.price ?? it.original_price ?? 0;
      const unitNew = it.final_price ?? unitOld;
      const lineOld = it.original_line_price ?? (unitOld * it.quantity);
      const lineNew = it.final_line_price ?? (unitNew * it.quantity);

      const discounts = (it.line_level_discount_allocations||[]).map(d => `
        <div class="mds-cart__discount"><span>${d.discount_application?.title || 'Discount'}</span><span>- ${money(d.amount)}</span></div>`).join('');

      list.insertAdjacentHTML('beforeend', `
        <div class="mds-cart__item" data-key="${it.key}" data-line="${i+1}">
          <img class="mds-cart__thumb" src="${it.image || it.featured_image?.url || ''}" alt="">
          <div>
            <div class="mds-cart__title">${it.product_title || it.title || ''}</div>
            <div class="mds-cart__variant">${it.variant_title || ''}</div>
            <div class="d-flex align-items-center gap-2 mt-2">
              <div class="mds-cart__qty">
                <input type="number" class="form-control form-control-sm" value="${it.quantity}" min="0" step="1" style="width:72px;">
              </div>
              <span class="mds-cart__remove" data-remove>Remove</span>
            </div>
            ${discounts ? `<div class="mds-cart__discounts">${discounts}</div>` : ''}
          </div>
          <div class="mds-cart__price">
            ${lineOld !== lineNew ? `<span class="old">${money(lineOld)}</span>` : ''}
            <span class="new">${money(lineNew)}</span>
          </div>
        </div>`);
    });

    $('#mdsCartSubtotal').textContent = money(cart.total_price || 0);
    const dwrap = $('#mdsCartDiscounts');
    if (dwrap){
      dwrap.innerHTML = '';
      (cart.cart_level_discount_applications||[]).forEach(d=>{
        dwrap.insertAdjacentHTML('beforeend', `<div class="mds-cart__discount"><span>${d.title}</span><span>- ${money(d.total_allocated_amount)}</span></div>`);
      });
    }
    
    // Update shipping progress bar
    updateShippingProgress(cart.total_price || 0);
  }

  function init(){
    ensureDrawer();

    // ATC capture: any button with data-variant-id
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('button[data-variant-id]');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      try {
        btn.disabled = true;
        const qty = Number(btn.dataset.qty)||1;
        await cartAdd(btn.dataset.variantId, qty);
        const cart = await cartGet();
        renderCart(cart);
        updateHeaderCount(cart.item_count);
        document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles:true }));
        openDrawer();
      } catch (err) {
        console.error('ATC error', err);
      } finally { btn.disabled = false; }
    }, { capture: true });

    // Drawer close controls, ESC
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-mds-cart-close]')) { e.preventDefault(); closeDrawer(); }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

    // Qty / remove delegation
    $('#mds-cart')?.addEventListener('click', async (e) => {
      const row = e.target.closest('.mds-cart__item'); if (!row) return;
      const key = row.dataset.key, line = Number(row.dataset.line);
      if (e.target.matches('[data-remove]'))  {
        const cart = await cartChange(key || line, 0);
        renderCart(cart); updateHeaderCount(cart.item_count);
        document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles:true }));
      }
    });

    // Manual qty edit (number input)
    $('#mds-cart')?.addEventListener('change', (e) => {
      const input = e.target;
      if (input.closest('.mds-cart__item') && input.tagName === 'INPUT'){
        const row = input.closest('.mds-cart__item');
        const key = row.dataset.key, line = Number(row.dataset.line);
        const q = Math.max(0, parseInt(input.value||'1',10) || 0);
        cartChange(key || line, q).then(cart => {
          renderCart(cart); updateHeaderCount(cart.item_count);
          document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles:true }));
        }).catch(err => console.error('Change qty error', err));
      }
    });
  }

  // Initialize when DOM ready
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();